import { render } from "./PageToolbar.vue?vue&type=template&id=6d644025&scoped=true"
import script from "./PageToolbar.vue?vue&type=script&lang=js"
export * from "./PageToolbar.vue?vue&type=script&lang=js"

import "./PageToolbar.vue?vue&type=style&index=0&id=6d644025&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d644025"]])

export default __exports__